import { Routes } from '@angular/router';
import { LayoutAuthComponent } from './common/components/layout-auth/layout-auth.component';
import { BaseLayoutComponent } from '@aando/core';
import { ngxProtectedGuard, ngxPublicGuard } from 'ngx-auth';

export const routes: Routes = [
  {
    path: '',
    canActivate: [ngxPublicGuard],
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/login/routes/login.routes').then((c) => c.LOGIN_ROUTES),
      },
      {
        path: 'confirm',
        loadChildren: () =>
          import('./pages/confirm/routes/confirm.routes').then((c) => c.CONFIRM_ROUTES),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./pages/reset-password/routes/reset-password.routes').then(
            (c) => c.RESET_PASSWORD_ROUTES,
          ),
      },
    ],
  },
  {
    path: '',
    canActivate: [ngxProtectedGuard],
    component: BaseLayoutComponent,
    children: [
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile/routes/profile.routes').then((c) => c.PROFILE_ROUTES),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./pages/notifications/routes/notifications.routes').then(
            (c) => c.NOTIFICATIONS_ROUTES,
          ),
      },
      {
        path: 'chats-center',
        loadChildren: () =>
          import('./pages/chats-center/routes/chats-center.routes').then(
            (c) => c.CHATS_CENTER_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'counterparty-registration',
    component: LayoutAuthComponent,
    loadChildren: () =>
      import('./pages/counterparty-registration/routes/counterparty-registration.routes').then(
        (c) => c.COUNTERPARTY_REGISTRATION_ROUTES,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
